/** Small formatting helpers — keep dependency footprint minimal. */

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return iso;
  const sec = Math.round(ms / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const d = Math.round(hr / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}

export function formatDuration(startIso: string | null, endIso: string | null): string {
  if (!startIso) return '—';
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : Date.now();
  const seconds = Math.max(0, Math.round((end - start) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return `${m}m ${s}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

export function formatCost(usd: number | null | undefined): string {
  if (usd == null) return '—';
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(2)}`;
}

export function shortId(id: string, head = 6, tail = 4): string {
  if (id.length <= head + tail + 2) return id;
  return `${id.slice(0, head)}…${id.slice(-tail)}`;
}

export function archetypeLabel(slug: string): string {
  const labels: Record<string, string> = {
    youth_coach: 'Youth Coach',
    baseball_parent: 'Baseball Parent',
    d1_pitcher: 'D1 Pitcher',
    travel_ball_mom: 'Travel Ball Mom',
    scout_evaluator: 'Scout',
    hs_athlete: 'HS Athlete',
    fitness_coach: 'Fitness Coach',
    home_workout_creator: 'Home Workout Creator',
    gym_lifestyle: 'Gym Lifestyle',
  };
  return labels[slug] ?? slug;
}
